(function() {
  const AUTOPLAY_INTERVAL = 6000;

  function initHeroCarousel() {
    const carousel = document.getElementById('selfco-hero-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.selfco-hero__slide');
    const dots = carousel.querySelectorAll('.selfco-hero__dot');
    const cards = carousel.querySelectorAll('.selfco-hero__float-card');
    let currentSlide = 0;
    let autoplayInterval = null;

    function goToSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('selfco-hero__slide--active', i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('selfco-hero__dot--active', i === index);
      });
      cards.forEach((card, i) => {
        card.classList.toggle('selfco-hero__float-card--visible', i === index);
      });
      currentSlide = index;
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, AUTOPLAY_INTERVAL);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goToSlide(parseInt(this.dataset.dot));
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Cleanup on section unload (Shopify theme editor)
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.target.contains(carousel)) {
        stopAutoplay();
      }
    });

    // Cleanup on page visibility change
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    startAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCarousel);
  } else {
    initHeroCarousel();
  }

  // Reinitialize when section is reloaded in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('#selfco-hero-carousel')) {
      initHeroCarousel();
    }
  });
})();
